import React from "react";

const ProductAttributes = ({ attributes = {} }) => {
  return (
    <div className="mt-6 md:mt-10">
      <h2 className="font-bold text-lg md:text-2xl mb-6 md:mb-8 text-gray-900">
        Product Attributes
      </h2>
      <div className="grid grid-cols-2 w-full">
        <div className="font-bold text-sm md:text-base py-3 border-b border-gray-100 text-gray-900">Type</div>
        <div className="font-bold text-sm md:text-base py-3 border-b border-gray-100 text-gray-900">Description</div>
        {Object.entries(attributes).length > 0 ? (
          Object.entries(attributes).map(([key, value]) => (
            <React.Fragment key={key}>
              <div className="py-2 md:py-3 border-b border-gray-50 text-gray-600 text-xs md:text-sm font-medium pr-4">{key}</div>
              <div className="py-2 md:py-3 border-b border-gray-50 text-gray-800 text-xs md:text-sm">{value || "-"}</div>
            </React.Fragment>
          ))
        ) : (
          <p className="col-span-2 py-4 text-gray-400 italic text-sm">No attributes available.</p>
        )}
      </div>
    </div>
  );
};

export default ProductAttributes;
